import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ar from "date-fns/locale/ar";
import { useTranslation } from "react-i18next";
import { RangedCalendarClearIcon, RangedCalendarIcon } from "../../assets/icons/MUI/UIComponentsIcons";
import { Box, IconButton } from "@mui/material";

type CustomInputProps = {
  value?: string;
  onClick?: () => void;
};

const CustomInput = React.forwardRef(({ value, onClick }: CustomInputProps, ref: React.Ref<HTMLButtonElement>) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      ref={ref}
      style={{
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        color: "var(--Gray-700, #344054)",
        fontFamily: "Montserrat",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        background: "transparent",
        border: "none",
        padding: 0,
      }}
    >
      <span>{value || t("components.rangedDatePicker.pickYourDate")}</span>
      <RangedCalendarIcon />
    </button>
  );
});

interface RangedDatePickerProps {
  dateRange: [Date | null, Date | null];
  setDateRange: React.Dispatch<React.SetStateAction<[Date | null, Date | null]>>;
}
const RangedDatePicker = ({ dateRange, setDateRange }: RangedDatePickerProps) => {
  const { t, i18n } = useTranslation();
  const [startDate, endDate] = dateRange;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "7.5px 16px",
        borderRadius: "8px",
        border: "1px solid var(--Gray-300, #D0D5DD)",
        background: "var(--Base-White, #FFF)",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        height: "fit-content",
        textWrap: "nowrap",
      }}
    >
      {(!!dateRange[0] || !!dateRange[1]) && (
        <IconButton
          onClick={() => setDateRange([null, null])}
          sx={{
            padding: 0,
          }}
        >
          <RangedCalendarClearIcon />
        </IconButton>
      )}
      <DatePicker
        onChange={(update: [Date | null, Date | null] | Date | null) => {
          if (Array.isArray(update)) {
            setDateRange(update);
          }
        }}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        customInput={<CustomInput />}
        dateFormat="dd MMM, yyyy"
        locale={i18n.language === "ar" ? ar : undefined}
      />
    </Box>
  );
};

export default RangedDatePicker;
